export default "__VITE_ASSET__CoXSbwIL__"